import { Page } from "src/components";
import { Freezer } from "src/components/Freezer/Freezer";

export const PageFreezer = () => (
  <Page>
    <Freezer />
  </Page>
);
